import React from 'react';
import Wrapper from './Wrapper';

/** renders a Wrapper that is styled to fill the entire page */
const PageWrapper = (props) => <Wrapper {...props} className="page-wrapper" />;

export default PageWrapper;
